import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function ContentBlocks3({data}) {
    const {contentBlocks3BottomText, contentBlocks3Text, contentBlocks3Title, contentBlocks3Blocks} = data
    return (
        <div className='why-now-wrap light-grey-bg'>
            <div className='container sm-container-1'>
                <div className='row'>
                    <div className='col-md-12 text-center heading-head-sec'>
                        <figure className='choose-world-icon'>
                            <StaticImage
                                src='../../../images/our-work-choose-icon.png'
                                alt='image'
                            />
                        </figure>
                        <h2 className='heading-level-2 blue-color'>{contentBlocks3Title && parser(contentBlocks3Title)}</h2>
                        {contentBlocks3Text && parser(contentBlocks3Text)}
                    </div>
                </div>
            </div>
            <div className='container'>
                <div className='row white-box-row pink-bold-p'>
                    {contentBlocks3Blocks?.map((block, i) => (
                        <div className={`col-md-${i < 3 ? 4 : 6} w-col-box`} key={i}>
                            <div className='white-box-col-1 d-white-bx'>
                                <h4 className='heading-level-4-b'>
                                    {block.contentBlocks3BlockTitle && parser(block.contentBlocks3BlockTitle)}
                                </h4>
                                <p>
                                    {block.contentBlocks3BlockText && parser(block.contentBlocks3BlockText)}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='row pink-bold-p'>
                    <div className='col-md-12'>
                        <div className='choose-world-btm-sec text-center'>
                            <p>{contentBlocks3BottomText && parser(contentBlocks3BottomText)}</p>
                            <figure className='choose-head-icon'>
                                <StaticImage src='../../../images/hand-icon.png' alt='image' />
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
